import { useEventContext } from './useEventContext';
import { useCallback } from 'react';
import { gql } from '@apollo/client';
import {
  graphql,
  useAnalytics,
  METRICS_EVENTS_SAVED_COUNT,
} from '@xolv-mybrightlink/common';

const ADD_EVENT_BOOKMARK = gql`
  mutation addBookmarkItem($slug: String) {
    bookmarkItem(bookmark: { slug: $slug, type: "event" })
  }
`;

const bookmarkEvent = async (slug: string) => {
  await graphql.mutate({
    mutation: ADD_EVENT_BOOKMARK,
    variables: { slug },
  });
};

const REMOVE_EVENT_BOOKMARK = gql`
  mutation removeBookmarkedItem($slug: String) {
    removeBookmarkedItem(bookmark: { slug: $slug, type: "event" })
  }
`;

export const removeBookmarkEvent = async (slug: string) => {
  await graphql.mutate({
    mutation: REMOVE_EVENT_BOOKMARK,
    variables: { slug },
  });
};

export const useBookmarkEvent = () => {
  const [state, dispatch] = useEventContext();
  const analytics = useAnalytics();
  return useCallback(
    async (databaseId: number, categoryId: string) => {
      if (state.initial) {
        return;
      }
      let event = state.data[categoryId]?.events.find(
        (item) => item.databaseId === databaseId,
      );
      if (!event) {
        const eventDetails = state.eventDetails.find(
          (item) => item.databaseId === databaseId,
        );
        const eventDetailsData = eventDetails?.data;
        if (eventDetailsData && typeof eventDetailsData !== 'string') {
          event = eventDetailsData;
        }
      }
      if (event) {
        if (event.isSaved) {
          await removeBookmarkEvent(event.slug);
          analytics.incrementUserProperty(METRICS_EVENTS_SAVED_COUNT, -1);
        } else {
          await bookmarkEvent(event?.slug);
          analytics.incrementUserProperty(METRICS_EVENTS_SAVED_COUNT, 1);
        }
        dispatch({
          type: 'bookmark',
          databaseId,
        });
      }
    },
    [dispatch, state, analytics],
  );
};
